import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Http = () => {
  return (
    <StartInterviewLayout type="http"/>
  )
}

export default Http;